import {RefObject, useEffect, useState} from 'react';
import {targetTotalMillis, targetUpdateEvery} from 'components/ContentPagesComponents/Charts/timing';
import {useInView} from 'framer-motion';
import {useIsMobile} from 'hooks/useIsMobile';

const timings = (target: number): number[] => {
	const slices = targetTotalMillis / targetUpdateEvery;
	const delta = target / slices;
	return [targetUpdateEvery, delta];
};

export const useTimerInView = (
	ref: RefObject<Element>,
	target: number,
) => {
	const mobile = useIsMobile();
	const isInView = useInView(ref, {once: !mobile});
	const [value, setValue] = useState(0);

	// Prepare useEffect to trigger
	useEffect(() => {
		if (isInView) {
			const [interval, increment] = timings(target);
			const handle = setInterval(() => {
				setValue((prev) => {
					if (prev + increment >= target) {
						clearInterval(handle);
					}
					return Math.min(prev + increment, target);
				});
			}, interval);
			return () => clearInterval(handle);
		}
	}, [isInView]);

	return value;
};
